import React, { useState } from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomLoader from '../../common/CustomLoader';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const UpdateEnvConstantValue = ({
  constant,
  showForm,
  updateEnvConstantPending,
  setShowForm,
  handleSubmit,
}) => {
  const [constantValue, setConstantValue] = useState(constant.value);

  return (
    <Modal size="lg" isOpen={showForm} toggle={setShowForm} backdrop="static">
      <ModalHeader toggle={setShowForm} className="border-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <strong>Edit {constant.name}'s Value</strong>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="row d-inline">
          <div className="row" style={{ top: '-10px' }}>
            <textarea
              type="text"
              className="w-100 mt-2"
              rows={constantValue.length / 40}
              value={constantValue}
              onChange={(e) => setConstantValue(e.target.value)}
            ></textarea>
          </div>
          <div className="row d-flex justify-content-end " style={{ marginTop: '1rem' }}>
            <button
              type="button"
              className="btn btn-default btn-md"
              onClick={() => {
                setShowForm(false);
              }}
            >
              <i className={`wb ${drapcodeIcon('clear')}`}></i>&nbsp;Clear
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-theme-submit btn-md"
              disabled={updateEnvConstantPending ? 'disabled' : ''}
              onClick={() => handleSubmit(constantValue)}
            >
              <i className="wb webconnect-plus"></i>&nbsp;Update
              <CustomLoader loading={updateEnvConstantPending} />
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UpdateEnvConstantValue;
